var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "100%",
    y1: "37.93%",
    y2: "62.07%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa48d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b72136"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m2.15609375.29484375h12.00031245c1.1045695 0 2 .8954305 2 2v15.99953125h-16.00031245v-15.99953125c0-1.1045695.8954305-2 2-2z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24 9.585-.703 8.935h-22.594l-.703-8.935 4-2.857h16z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.844 .719)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#d0f2ff",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.21345312 3.02020312h4.74279688c.11045695 0 .2.08954306.2.2v1.00625c0 .11045695-.08954305.2-.2.2h-4.74279688c-.11045694 0-.2-.08954305-.2-.2v-1.00625c0-.11045694.08954306-.2.2-.2zm.00014063 3.42839063h9.88531245c.110457 0 .2.08954305.2.2v1.00625c0 .11045695-.089543.2-.2.2h-9.88531245c-.11045695 0-.2-.08954305-.2-.2v-1.00625c0-.11045695.08954305-.2.2-.2zm0 3.4284375h9.88531245c.110457 0 .2.08954305.2.19999995v1.00625c0 .110457-.089543.2-.2.2h-9.88531245c-.11045695 0-.2-.089543-.2-.2v-1.00625c0-.1104569.08954305-.19999995.2-.19999995z",
    fill: "#74caff",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24 9.585v13.714l-12-1.115-12 1.115v-13.714l9.6 6.857h4.8z",
    fill: "#ffa48d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 9.585v13.714l-12-1.115v-5.742h2.4z",
    fill: "#ff4842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 23.299h-24l12-8.571z",
    fill: "#ff4842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 23.299h-12v-8.571z",
    fill: "#b72136"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationMail);
export default __webpack_public_path__ + "static/media/notification_mail.0a524554147a6224214ed5dd7f486214.svg";
export { ForwardRef as ReactComponent };